import React from 'react';
import Container from 'react-bootstrap/Container';
import Card from 'react-bootstrap/Card';
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import FloatingLabel from 'react-bootstrap/FloatingLabel';
import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';
import Modal from 'react-bootstrap/Modal';
import PulseLoader from "react-spinners/PulseLoader";
import { useEffect, useState, useRef } from "react";
import { useNavigate } from "react-router-dom";
import $ from 'jquery';
//import { BackToKdealerLogin, LogoutDealer, LoginDealer } from '../GlobalScript'
import Table from 'react-bootstrap/Table';
import Cookies from 'js-cookie';
import { GetDomain, RemoveCookie, GetCoockie, days, user_session_id, shopping_cart_session_days, shopping_cart_session_id } from "../GlobalScript";
export default function SSOTest() {
    const navigate = useNavigate();
    const [UserInfo, setUserInfo] = useState(null);
    const [Loading, setLoading] = useState(true);
    //const days = 8/24;
    const LoginUser = async (id) => {
        try {
            debugger;
            const response = await fetch("kdealer/ValidateUser/" + id);
            if (response.status !== 200) {
                throw new Error("Invlaid user!");
            }
            const usrSession = await response.json();

            //LoginDealer(usrSession.userKey, usrSession.dealerKey, usrSession.firstName, usrSession.lastName, usrSession.email);
            const userObj = {
                'firstName': usrSession.firstName,
                'lastName': usrSession.lastName,
                'email': usrSession.email,
                'dealerKey': usrSession.dealerKey,
                'userKey': usrSession.userKey,
                'dealerName': usrSession.dealerName,
                'dealerID': usrSession.dealerID,
                'loginType': usrSession.loginType,
                'region': usrSession.region,
                'address': usrSession.address,
                'loading': 0
            };
            let domain = GetDomain();
            console.log('domain: ' + domain);
            if (domain === '') {
                Cookies.set('user', JSON.stringify(userObj), { expires: days });
            }
            else {
                Cookies.set('user', JSON.stringify(userObj), { expires: days, domain: domain,secure:true});
            }
            //Cookies.set('user', userObj, { expires: 8/24 });
            //setUserInfo(userObj);
            setUserInfo({
                'firstName': usrSession.firstName,
                'lastName': usrSession.lastName,
                'email': usrSession.email,
                'dealerKey': usrSession.dealerKey,
                'userKey': usrSession.userKey,
                'loginType': usrSession.loginType,
                'kmcst': usrSession.KMCST,
                'dealerID': usrSession.dealerID,
                'rdmString': id
            });
            localStorage.clear();
            window.GlobalLoading = 0;
            console.log('cookie: ' + GetCoockie());
            //window.location.href = '/dealerhome';
            if (usrSession.loginType === 1) {
                navigate('/dealerhome');
            }
            else if (usrSession.loginType === 5) {
                navigate('/kcountrieshome');
            }
            else { 
                navigate('/login');
            }          
        }
        catch (e) {
            //window.location.href = '/login';
            navigate('/login');
        }

    }
    useEffect(() => {
        if (Loading) {
            const queryParameters = new URLSearchParams(window.location.search);
            const id = queryParameters.get("id");
            if (!id) {
                navigate('/login');
            }
            LoginUser(id);
            setLoading(false);
        }
    }, [Loading])

    const LogoutDealerClick = () => {
        debugger;
        /* Cookies.remove('user', { expires: 8 / 24 });*/
        RemoveCookie(days, user_session_id);
        window.location.href = '/login';
        setUserInfo(null);
       
    }
    return (
        <>
            <Container className="checkout-container main-container">
                <Row className="order-table order-page">
                    {/*<Col className="hr-left checkout-title-under">Information Provided*/}
                    {/*</Col>*/}

                    {UserInfo ?
                        <>
                        </> :
                        <>
                        <Col>
                           Logging in...
                        </Col>
                        </>}


                   
                </Row>
            </Container>
        </>
    );
}